import { useEffect } from 'react';
import { AggregateEuRootResponse } from 'src/apis/aggregate-eu/types';
import { useAxios } from 'src/hooks/use-axios';

export function useAggregateEuRoot() {
  const aggregateEuRoot = useAxios(
    (axios, signal) =>
      axios.request<AggregateEuRootResponse>({
        signal,
        url: PRISMA_CONFIG.aggregateEu,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    aggregateEuRoot.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return aggregateEuRoot;
}

export type AggregateEuRootRequest = ReturnType<typeof useAggregateEuRoot>;
